import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Card, CardContent } from '@/components/ui/card';

const teamMembers = [
  {
    name: 'Mr JAVEED PASHA G',
    designation: 'Founder of Sagar Traders',
    image: '/Founder.png',
  },
  {
    name: 'Mr HUZAIFA IBRAHIM',
    designation: 'Managing Director of Sagar Ventures',
    image: '/md.png',
  },
];

export const TeamSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="team" className="py-20 lg:py-28 bg-muted/30" ref={ref}>
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="text-primary font-medium uppercase tracking-wider text-sm">
            Our Leadership
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mt-4 mb-6">
            Meet the People <span className="text-gradient-gold">Behind Sagar</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            The visionaries driving excellence in construction and home transformation
            across Arkalgud and beyond.
          </p>
        </motion.div>

        {/* Team Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.15 }}
            >
              <Card className="h-full card-premium border-border/50 overflow-hidden">
                <CardContent className="p-0">
                  {/* Image */}
                  <div className="relative aspect-[3/4] overflow-hidden rounded-t-xl">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-secondary/40 to-transparent" />
                  </div>

                  {/* Info */}
                  <div className="p-6 text-center">
                    <h3 className="font-display font-semibold text-foreground text-lg mb-1">
                      {member.name}
                    </h3>
                    <p className="text-primary text-sm font-medium">
                      {member.designation}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
